import { z } from 'zod';
import { IAsset } from './IAsset';
import { IAssetCategoryId } from './IAssetCategory';
import { IAssetTypeId } from './IAssetType';
import { GenericAssetSchema } from './IGenericAsset';

export const OtherAssetVersion = {
  Initial: 1,
} as const;

export type OtherAssetVersion =
  (typeof OtherAssetVersion)[keyof typeof OtherAssetVersion];

export function getEmptyOtherAsset(idAsset: number): IOtherAsset {
  return {
    idAsset,
    idAssetType: IAssetTypeId.Other,
    idAssetCategory: IAssetCategoryId.Other,
    Version: OtherAssetVersion.Initial,
    data: {
      notes: '',
    },
  };
}

export function isOtherAsset(asset: IAsset): asset is IOtherAsset {
  return asset.idAssetType === IAssetTypeId.Other;
}

export const OtherAssetDataSchema = z.object({
  notes: z.string().optional(),
});

export const OtherAssetSchema = GenericAssetSchema(
  z.literal(IAssetTypeId.Other),
  z.literal(IAssetCategoryId.Other),
  z.literal(OtherAssetVersion.Initial).optional(),
  OtherAssetDataSchema
);

export type IOtherAsset = z.infer<typeof OtherAssetSchema>;
